import API from './settings'


// Person
export const filterPersons = (formData: any = {}): any => {
    return API.post('/ALL/person/filter', formData);
};

export const getPerson = (person_id: string): any => {
    return API.get(`/ALL/person/get/${person_id}`);
};

export const createPerson = (formData: any): any => {
    return API.post('/ALL/person/create', formData);
};

export const editPerson = (person_id: string, formData: any): any => {
    return API.post(`/ALL/person/edit/${person_id}`, formData);
}

export const deletePerson = (person_id: string, formData: any = {}): any => {
    return API.post(`/ALL/person/remove/${person_id}`, formData);
};

export const getPersonAssignments = (): any => {
    return API.get('/ALL/person/assignments/get_count');
};

// User
export const validateToken = (token: any): any => {
    return API.post(`/ALL/user/validate_token/${token}`)
}

export const resetUserPassword = (formData: any): any => {
    return API.post('/ALL/user/reset_password', formData)
}

export const changeUserPassword = (formData: any): any => {
    return API.post('/ALL/user/change_password', formData)
}

export const filterUsers = (formData: any): any => {
    return API.post('/ALL/user/filter', formData);
};

export const getUser = (user_id: string): any => {
    return API.get(`/ALL/user/get/${user_id}`);
};

export const createUser = (formData: any): any => {
    return API.post('/ALL/user/create', formData);
};

export const editUser = (user_id: string, formData: any): any => {
    return API.post(`/ALL/user/edit/${user_id}`, formData);
}

